<template>
    <div>
        <div class="mainimagecontainer header-background">
            <div class="mainimage d-flex flex-row justify-content-around">
                <div class="centercolumn d-flex flex-column justify-content-around">
                    <div v-if="gobiId" id="gobi"></div>
                    <div class="tagline">{{ tagline }}</div>
                </div>
            </div>
        </div>
        <div class="leftrightmargin">
            <MainLayout hide-on-mobile="left right">
                <div slot="top">
                    <h5 class="mt-5">Upcoming Virtual Events</h5>
                    <VFairList
                        class="mt-4"
                        with-layout-toggle
                        :data="ownVFairs()"
                        :is-loading="loading()"
                    />
                </div>
                <div slot="top">
                    <h5 class="mt-5">Digital Campus Visits</h5>
                    <VFairList
                        class="mt-4"
                        with-layout-toggle
                        :data="otherVFairs()"
                        :is-loading="loading()"
                    />
                </div>
            </MainLayout>
        </div>
    </div>
</template>

<script>
import { Bubbles } from '@gobistories/gobi-web-integration';
import MainLayout from '../../components/layouts/mainlayout/MainLayout.vue';
import VFairList from '../vfairs/list/components/VFairList.vue';
import UniversityService from '../../services/UniversityService';

export default {
    name: 'Home',
    components: {
        MainLayout,
        VFairList,
    },
    data() {
        return {
            tagline: this.$getCustomProperty('tagline'),
            gobiId: this.$getCustomProperty('gobiId'),
            organizationId: undefined,
        };
    },
    computed: {
        vfairs() {
            if (this.organizationId) {
                return this.$interfaces.vfair.get({
                    reactive: true,
                    organization_id: this.organizationId,
                });
            } else {
                return {
                    data: [],
                    loading: true,
                };
            }
        },
    },
    mounted() {
        UniversityService.getCurrentSchoolData().then(schoolData => {
            this.organizationId = schoolData.id;
        });
        this.$interfaces.logInModule.setDisabledPopup();
        if (this.gobiId) {
            new Bubbles({
                container: '#gobi',
                playerOptions: {
                    autoStart: true,
                    logo: false,
                },
                bubbleSize: '120px',
                color: 'rgba(0, 0, 0, 0)',
                animatedBubble: true,
                stories: [{ id: this.gobiId }],
            });
        }
    },
    methods: {
        sortVFairs(vFairs) {
            return vFairs
                .filter(item => {
                    let check = item.start;
                    if (item.end) {
                        check = item.end;
                    }
                    let now = new Date();
                    let then = new Date(check);
                    return now <= then && item.active;
                })
                .sort((a, b) => (a.start > b.start ? 1 : -1));
        },
        ownVFairs() {
            return this.sortVFairs(this.vfairs.data).filter(vFair => vFair.visibility === 2);
        },
        otherVFairs() {
            return this.sortVFairs(this.vfairs.data).filter(
                vFair => vFair.visibility === 0 || vFair.visibility === 1
            );
        },
        loading() {
            return this.vfairs.loading;
        },
    },
};
</script>

<style scoped>
.mainimagecontainer {
    width: 100%;
    min-height: 300px;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 5%;
    padding-bottom: 6%;
}

.centercolumn {
    width: 60%;
    height: 100%;
}
.tagline {
    font-family: 'Open Sans', Helvetica, Arial, Lucida, sans-serif;
    font-weight: 700;
    font-size: 45px;
    text-align: center;
    color: #fff;
}
.leftrightmargin {
    margin-left: 2%;
    margin-right: 2%;
}
</style>
